import React from 'react';
import {Home, About, Services, Products, Menu, Team, Testimonials, Blogs, Contact, Gallery, Clients} from '../../sections'; 
import { Counter } from '../../components';

 
const HomePage = () => { 
  return ( 
      <div className='homepage'>
        <Home />
        <About />
        <Services />
        <Menu />
        <Gallery />
        <Products /> 
        <Counter />
        <Team />
        <Blogs />
        <Testimonials />
        <Contact />
        <Clients />
      </div>
  )
}

export default HomePage;